import React, { useState, useEffect } from 'react'
import useModal from 'hook/useModal'

// css
import 'assets/style/elements/search-bar.scss'

// elements
import TextInput from 'components/elements/TextInput'
import IconButton from 'components/elements/IconButton'

function Element({ className, keyword = '', goSearch = () => {} }) {
  const [text, setText] = useState(keyword) // 검색어

  const onChange = (e) => {
    setText(e.target.value)
  }

  const onKeyUp = (e) => {
    if (e.key === 'Enter') {
      goSearch(text)
    }
  }

  return (
    <section className={'search-bar ' + className}>
      <TextInput placeholder="검색어를 입력하세요." value={text} onChange={onChange} onKeyUp={onKeyUp} />
      <IconButton size="40" type="search" color="white" bg="green" alt="검색" onClick={() => goSearch(text)} />
    </section>
  )
}

export default Element
